import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SimulationService {

  constructor() { }

  openSimulationModal(title?: string, value?: string, beforeConfirm?: (data: any) => Promise<any>) {
    const titleText = title || 'Faça uma Simulação';

    // Convert abbreviated format to full monetary format for display
    let displayValue = value;
    if (value) {
      // Parse the abbreviated format (e.g., "R$ 200 mil" or "R$ 1,5 milhões")
      const numericValue = this.parseAbbreviatedValue(value);
      if (numericValue) {
        displayValue = numericValue.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
      }
    }

    return Swal.fire({
      title: titleText,
      customClass: {
        popup: 'premium-swal-popup',
        confirmButton: 'swal2-confirm',
        cancelButton: 'swal2-cancel'
      },
      html: `
        <div style="display: flex; flex-direction: column; text-align: left;">
          ${displayValue ? `
            <div style="text-align: center;">
              <span class="swal-value-badge">Valor selecionado: ${displayValue}</span>
            </div>` : ''}

          <div style="margin-bottom: 20px;">
            <label class="swal-field-label">Nome Completo</label>
            <input id="swal-name" class="swal2-input" placeholder="Ex: João Silva">
          </div>

          <div style="margin-bottom: 20px;">
            <label class="swal-field-label">E-mail</label>
            <input id="swal-email" type="email" class="swal2-input" placeholder="seu@email.com">
          </div>

          <div>
            <label class="swal-field-label">Telefone / WhatsApp</label>
            <input id="swal-phone" type="tel" class="swal2-input" placeholder="(00) 00000-0000" maxlength="15">
          </div>
        </div>
      `,
      focusConfirm: false,
      showCloseButton: true,
      confirmButtonText: 'Solicitar Simulação',
      cancelButtonText: 'Cancelar',
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      didOpen: () => {
        const phoneInput = document.getElementById('swal-phone') as HTMLInputElement;
        phoneInput.addEventListener('input', (event: any) => {
          let value = event.target.value.replace(/\D/g, '');
          if (value.length > 11) value = value.substring(0, 11);

          if (value.length > 10) {
            value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          } else if (value.length > 6) {
            value = value.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
          } else if (value.length > 2) {
            value = value.replace(/^(\d{2})(\d{0,4})/, '($1) $2');
          } else if (value.length > 0) {
            value = value.replace(/^(\d*)/, '($1');
          }
          phoneInput.value = value;
        });
      },
      preConfirm: async () => {
        const name = (document.getElementById('swal-name') as HTMLInputElement).value;
        const email = (document.getElementById('swal-email') as HTMLInputElement).value;
        const phone = (document.getElementById('swal-phone') as HTMLInputElement).value;

        if (!name || !email || !phone) {
          Swal.showValidationMessage('Por favor, preencha todos os campos obrigatórios');
          return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          Swal.showValidationMessage('Por favor, insira um e-mail válido');
          return false;
        }

        const data = { name, email, phone, valorFormatado: displayValue };

        if (beforeConfirm) {
          try {
            return await beforeConfirm(data);
          } catch (error) {
            // Extract error message from HttpErrorResponse or other error objects
            let errorMessage = 'Erro ao enviar a solicitação. Por favor, tente novamente.';
            if (error && typeof error === 'object') {
              if ('status' in error && 'statusText' in error) {
                // HttpErrorResponse
                errorMessage = `Erro ao enviar (${(error as any).status}). Por favor, tente novamente mais tarde.`;
              } else if ('message' in error) {
                errorMessage = (error as any).message;
              }
            }
            Swal.showValidationMessage(errorMessage);
            return false;
          }
        }

        return data;
      }
    });
  }

  // Helper method to parse abbreviated values like "R$ 200 mil" or "R$ 1,5 milhões"
  private parseAbbreviatedValue(value: string): number | null {
    // Remove "R$" and trim
    const cleaned = value.replace('R$', '').trim();

    // Check for "milhões" or "milhão"
    if (cleaned.includes('milhões') || cleaned.includes('milhão')) {
      const numStr = cleaned.replace(/milhões|milhão/g, '').trim().replace(',', '.');
      return parseFloat(numStr) * 1000000;
    }

    // Check for "mil"
    if (cleaned.includes('mil')) {
      const numStr = cleaned.replace('mil', '').trim().replace(',', '.');
      return parseFloat(numStr) * 1000;
    }

    return null;
  }

  showSuccessAlert() {
    return Swal.fire({
      title: 'Sucesso!',
      text: 'Sua solicitação foi enviada com sucesso. Em breve um consultor entrará em contato.',
      icon: 'success',
      iconColor: '#00a1ff',
      customClass: {
        popup: 'premium-swal-popup',
        confirmButton: 'swal2-confirm'
      },
      buttonsStyling: false,
      confirmButtonText: 'Entendido'
    });
  }

  showErrorAlert() {
    return Swal.fire({
      title: 'Ops!',
      text: 'Ocorreu um erro ao enviar sua solicitação. Por favor, tente novamente mais tarde ou fale conosco via WhatsApp.',
      icon: 'error',
      iconColor: '#e74c3c',
      customClass: {
        popup: 'premium-swal-popup',
        confirmButton: 'swal2-confirm'
      },
      buttonsStyling: false,
      confirmButtonText: 'Fechar'
    });
  }

  showWarningAlert(message: string) {
    return Swal.fire({
      title: 'Atenção',
      text: message,
      icon: 'warning',
      iconColor: '#f1c40f',
      customClass: {
        popup: 'premium-swal-popup',
        confirmButton: 'swal2-confirm'
      },
      buttonsStyling: false,
      confirmButtonText: 'Corrigir Agora'
    });
  }
}
